var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'E': _vm.lang=='E'},attrs:{"id":"app"}},[_c('div',{ref:"layer",attrs:{"id":"layer"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }